module.exports = "<p>\n  users works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/users.component.html
// module id = ./src/app/users/users.component.html
// module chunks = main